import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import ScrollToTop from '@/components/layout/ScrollToTop';
import AnimatedBackground from '@/components/layout/AnimatedBackground';
import PageTransition from '@/components/layout/PageTransition';
import HomePage from '@/pages/HomePage';
import ProductsPage from '@/pages/ProductsPage';
import BoardDetailPage from '@/pages/BoardDetailPage';
import ArenaPage from '@/pages/ArenaPage';
import ArenaRulesPage from '@/pages/ArenaRulesPage';
import ShopPage from '@/pages/ShopPage';
import ShopDetailPage from '@/pages/ShopDetailPage';
import ModelsPage from '@/pages/ModelsPage';
import ModelDetailPage from '@/pages/ModelDetailPage';
import RankingsPage from '@/pages/RankingsPage';
import EducationPage from '@/pages/EducationPage';
import EventsPage from '@/pages/EventsPage';
import EventDetailPage from '@/pages/EventDetailPage';
import ResourcesPage from '@/pages/ResourcesPage';
import AboutPage from '@/pages/AboutPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <PageTransition key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:boardId" element={<BoardDetailPage />} />
          <Route path="/arena" element={<ArenaPage />} />
          <Route path="/arena/rules" element={<ArenaRulesPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/:productId" element={<ShopDetailPage />} />
          <Route path="/models" element={<ModelsPage />} />
          <Route path="/models/:modelId" element={<ModelDetailPage />} />
          <Route path="/rankings" element={<RankingsPage />} />
          <Route path="/education" element={<EducationPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/:eventId" element={<EventDetailPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Routes>
      </PageTransition>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <HashRouter>
      <div className="min-h-screen relative">
        <AnimatedBackground />
        <div className="relative z-10">
          <Navbar />
          <ScrollToTop />
          <main className="hex-bg">
            <AnimatedRoutes />
          </main>
          <Footer />
        </div>
      </div>
    </HashRouter>
  );
}
